import LandingPageSetupMilestones from './LandingPageSetupMilestones';
export default LandingPageSetupMilestones;